import React from "react";

import { AdminOverviewBody } from "@src/features/admin/pages/overview/AdminOverview.body";

import { useViewPage } from "../../../../hooks/mixpanel";

export const AdminOverviewRoute = () => {
  useViewPage("admin/overview");

  return <AdminOverviewBody />;
};
